import {configureStore} from "@reduxjs/toolkit";
// @ts-ignore
import rootReducer from "./reducers";

const store = configureStore({
  reducer: rootReducer(),
})

export default store;
